import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SubmenuComponent } from './submenu.component';

@NgModule({
  declarations: [SubmenuComponent],
  imports: [CommonModule],
  exports: [SubmenuComponent],
})
export class SubmenuModule {}
